import * as Sentry from '@sentry/react';
import type { AppUser } from 'common/models';

export const setUserToSentry = (user: AppUser) => {
  Sentry.setUser(user);
};

export const clearUserFromSentry = () => {
  Sentry.setUser(null);
};

export const setLanguageToSentry = (language: string) => {
  Sentry.setContext('language', { language });
};
